"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var message_exports = {};
__export(message_exports, {
  messageCounts: () => messageCounts,
  messageHighlight: () => messageHighlight,
  pageMessageCounts: () => pageMessageCounts
});
module.exports = __toCommonJS(message_exports);
var import_util = require("@cartographerio/util");
var import_guard = require("../guard.js");
function messageCounts(messages) {
  return {
    errorCount: messages.filter((msg) => msg.level === "error").length,
    infoCount: messages.filter((msg) => msg.level === "info").length
  };
}
function pageMessageCounts(blockStates) {
  let errorCount = 0;
  let infoCount = 0;
  function handleField(state) {
    errorCount += state.errorCount;
    infoCount += state.infoCount;
  }
  function handleContent(state) {
    switch (state.type) {
      case "DynamicGridState":
      case "DynamicValueState":
      case "DynamicImageState":
      case "TextState":
      case "HeadingState":
        break;
      case "GroupState":
        state.blockStates.forEach(handleBlock);
        break;
      case "RepeatState":
        state.childStates.forEach(handleBlock);
        break;
      case "CardState":
      case "FullWidthState":
      case "RequireRoleState":
      case "ScopeState":
      case "VisibilityState":
        handleBlock(state.childState);
        break;
      case "PrimarySurveyorFieldState":
      case "PrimaryTeamFieldState":
        handleField(state);
        break;
      default:
        (0, import_util.checkExhausted)(state);
    }
  }
  function handleBlock(state) {
    if ((0, import_guard.isFieldState)(state)) {
      handleField(state);
    } else {
      handleContent(state);
    }
  }
  blockStates.forEach(handleBlock);
  return { errorCount, infoCount };
}
function messageHighlight(counts) {
  return counts.errorCount > 0 ? "error" : counts.infoCount > 0 ? "info" : void 0;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  messageCounts,
  messageHighlight,
  pageMessageCounts
});
//# sourceMappingURL=message.js.map
